import { DrawerComponent } from '@shared/components/drawer';
import { SelectionModel } from '@angular/cdk/collections';
import { DatePipe } from '@angular/common';
import { Component, inject, ChangeDetectionStrategy } from '@angular/core';
import { ButtonComponent } from '@shared/components/button';
import { FormControl } from '@angular/forms';
import { Evenement } from './evenements.interface';
import { EvenementsService } from './evenements.service';
import { PanelEvenementDetailComponent } from './panel-evenement-detail/panel-evenement-detail.component';

import 'moment/locale/fr';
import { openSliderAnimation, voirDetailAnimation } from '../../../partage/animations/animations';
import { PDFViewerComponent } from '../../../partage/components/PDF-viewer/pdf-viewer/pdf-viewer.component';
import { DATE_FORMAT_CONFIG } from '../../../partage/providers';
import { FactureService } from '../../facturation/facture.service';
import { PdfAction } from '../global/global-reddition.interface';
import { EvenementFiltreComponent } from './evenement-filtre/evenement-filtre.component';
import { EvenementsListeComponent } from './evenements-liste/evenements-liste.component';

@Component({
  selector: 'app-evenements.route',
  templateUrl: './evenements.route.component.html',
  styleUrl: './evenements.route.component.scss',
  animations: [voirDetailAnimation, openSliderAnimation],
  providers: DATE_FORMAT_CONFIG,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    DrawerComponent,
    ButtonComponent,
    DatePipe,
    PanelEvenementDetailComponent,
    PDFViewerComponent,
    EvenementFiltreComponent,
    EvenementsListeComponent,
  ],
})
export class EvenementsRouteComponent {
  private evenementService = inject(EvenementsService);
  private factureService = inject(FactureService);
  voirDetailEvenement = this.evenementService.voirDetail;
  panelEvenement = this.evenementService.evenementSelection;
  voirPDF = this.factureService.voirPdf;
  aRedditionnerIsChecked = false;
  estArchiveIsChecked = false;
  selection = new SelectionModel<Evenement>(true, []);
  filtre = new FormControl('');
  clientSelection = this.evenementService.clientSelection;
  factureEnCours = this.evenementService.factureEnCours;
  pdfCourant = this.factureService.downloadedFile;
  statut: string = 'EnAttenteDeFacturation';

  telechargerFactureReddition(idReddition: string, action: PdfAction = PdfAction.telecharger) {
    this.factureService.redditionAction.set({
      id: idReddition,
      action: action,
    });
  }

  telechargerJustificationAcompte(idAcompte: string, action: PdfAction = PdfAction.telecharger) {
    this.factureService.acompteAction.set({
      id: idAcompte,
      action: action,
    });
  }

  telechargerDocumentCourant() {
    this.factureService.telechargerDocumentCourant();
  }

  fermerPanelDetails() {
    this.voirPDF.set(false);
    this.voirDetailEvenement.set(false);
    this.panelEvenement.set(undefined);
  }

  /** Ferme le tiroir : il porte a la fois le detail et la visionneuse de document. */
  protected fermerPanelLateral(): void {
    this.voirPDF.set(false);
    this.fermerPanelDetails();
  }
}
